import React from 'react';
import Spinner from '../../spinner';

export default function Send({
  onClick, color = '#000', disabled, isLoading,
}) {
  return (
    <button
      type="submit"
      className="icon-button"
      onClick={onClick}
      disabled={disabled}
    >
      {isLoading ? <Spinner style={{ borderLeftColor: '#000' }} />
        : (
          <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6578 16.5928L13.9574 24.6364C14.1597 25.1489 14.5129 25.588 14.9703 25.8953C15.4276 26.2027 15.9676 26.3637 16.5186 26.3573H16.5729C17.1333 26.3544 17.6792 26.1787 18.136 25.854C18.593 25.5293 18.9384 25.0715 19.1253 24.5431L26.666 4.07546C26.9114 3.40914 26.892 2.67377 26.6114 2.02126C26.331 1.36879 25.811 0.848802 25.1585 0.568376C24.506 0.287874 23.7708 0.268403 23.1045 0.51378L2.61625 8.06168C1.9137 8.3203 1.34565 8.85207 1.04105 9.53597C0.736608 10.2199 0.721441 10.9978 0.999151 11.693C1.27695 12.3882 1.82398 12.9417 2.51591 13.2274L10.6578 16.5928ZM1.88654 10.6316C1.88904 10.291 1.9964 9.95938 2.19388 9.68176C2.39139 9.40416 2.66956 9.19411 2.99055 9.08003L23.4782 1.53153C23.8843 1.38085 24.3327 1.39208 24.7308 1.56285C25.1289 1.73361 25.4461 2.05089 25.6169 2.44895C25.7877 2.847 25.7989 3.29549 25.6482 3.70152L18.1075 24.1669C17.9934 24.4884 17.7829 24.7667 17.5049 24.9644C17.227 25.162 16.8948 25.2692 16.5538 25.2715C16.2123 25.2851 15.875 25.1913 15.5894 25.0035C15.3038 24.8158 15.0841 24.5434 14.961 24.2244L11.6918 16.2549L18.8838 9.06148C19.0209 8.92442 19.0745 8.72461 19.0244 8.53734C18.9743 8.35011 18.8281 8.20386 18.6408 8.15352C18.4536 8.10333 18.2538 8.15686 18.1167 8.29381L10.8955 15.5174L2.9303 12.225C2.61384 12.0987 2.34394 11.8779 2.15726 11.5929C1.9704 11.3078 1.87592 10.9723 1.88654 10.6316Z"
              fill={color}
            />
          </svg>
        )
      }
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/send/index.jsx